import api from "../api";

export const createAppointment = async (payload) => {
  const response = await api.post("/PMSRoutes/ManageAppointment", payload);
  return response.data;
};

export const editPatientDetails = async (payload) => {
  const response = await api.post(
    "/PMSRoutes/ManageAppointment",
    payload
  );

  return response.data;
};

export const editPatientVitals = async (payload) => {
  const response = await api.post(
    "/PMSRoutes/ManageAppointment",
    payload
  );

  return response.data;
};  

export const confirmAppointment = async (payload) => {
  const response = await api.post("/PMSRoutes/ManageAppointment", payload);
  return response.data;
};

export const rescheduleAppointment = async (payload) => {
  const response = await api.post("/PMSRoutes/ManageAppointment", payload);
  return response.data;
};

export const rejectAppointment = async (payload) => {
  const response = await api.post("/PMSRoutes/ManageAppointment", payload);
  return response.data;
};

export const cancelAppointment = async (payload) => {
  const response = await api.post("/PMSRoutes/ManageAppointment", payload);
  return response.data;
};

export const appointmentDetailsById = async (payload) => {
  const response = await api.post("/PMSRoutes/PreviewByAppointmentId", payload);
  return response.data;
};

export const uploadAppointmentFile = async (formData) => {
  const response = await api.post("/PMSRoutes/AddAppointmentFile", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const deleteAppointmentFile = async (payload) => {
  const response = await api.post(
    "/PMSRoutes/DeleteAppointmentFile",
    payload
  );

  return response.data;
};

export const uploadSignatureImage = async (
  formData
) => {

  const response = await api.post(
    "/PMSRoutes/UploadSignatureImage",
    formData,
    {
      headers: {
        "Content-Type":
          "multipart/form-data",
      },
    }
  );

  return response.data;
};